import Tab from './Tab';
import { forOwn } from 'lodash-es';

export default class Tabs {

	/**
	 *
	 * @param options
	 * @param instance Any given instance - current Modals
	 */
	constructor (options, instance) {
		this.tabs = options;
		this.tabObjs = [];

		this.tabContainer = this.createContainer();

		forOwn(this.tabs, (tab) => {
			let tabObj = new Tab(tab, this, instance);
			this.tabObjs.push(tabObj);

			tabObj.tabItem.addEventListener('click', this.tabActive.bind(this, tabObj));

			tabObj.tabItem.appendChild(tabObj.tabAnchor);
			this.tabContainer.tabList.appendChild(tabObj.tabItem);
		});

		this.tabContainer.appendChild(this.tabContainer.tabList);

		this.triggerTabEvent(this.tabObjs[0]);
		this.tabActive(this.tabObjs[0]);
	}

	/**
	 * Creates the tab container
	 * @return {HTMLElement}
	 */
	createContainer () {
		let container = document.createElement('div');
		container.classList.add('tab-container');

		container.tabList = document.createElement('ul');
		container.tabList.classList.add('modal-tab-menu');

		return container;
	}

	triggerTabEvent (tab) {
		tab.tabAnchor.dispatchEvent(tab.tabTrigger);
	}

	/**
	 * Determines whcih tab is currently active (adds/removes classes based on which one has been clicked)
	 * @param tab
	 */
	tabActive (tab) {
		this.tabObjs.forEach((tabs) => {
			if (tabs.tabItem.classList.contains('active')) {
				tabs.tabItem.classList.remove('active');
				tabs.tabItem.firstElementChild.classList.remove('current-tab');
			}
		});

		tab.tabItem.classList.add('active');
		tab.tabAnchor.classList.add('current-tab');
	}

	/**
	 * Disable/re-enable tabs
	 * @param disable
	 */
	disableTabs (disable) {
		this.tabObjs.forEach((tabs) => {
			if (disable) {
				tabs.tabItem.classList.add('tab-disabled');
			} else {
				tabs.tabItem.classList.remove('tab-disabled');
			}
		});
	}

}
